import { render, staticRenderFns } from "./UpdateInformationDialog.vue?vue&type=template&id=7ffb5e4b&scoped=true&lang=pug&"
import script from "./UpdateInformationDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateInformationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffb5e4b",
  null
  
)

export default component.exports